import * as React from 'react';
import { ISpinButtonStyles, SpinButton, Stack, TextField } from '@fluentui/react';

import { IAgeGoup } from '../../../../../Models/AgeGroups/IAgeGroup';

interface IAgeGroupPropertiesFormProps {
    item: IAgeGoup;
 
    isLoading: boolean;
    propertyChanged: (key: string, value: any) => void;
    valid: (value: boolean)=> void;
}

const styles: Partial<ISpinButtonStyles> = { spinButtonWrapper: { width: 75 } };

export const AgeGroupPropertiesForm: React.FunctionComponent<IAgeGroupPropertiesFormProps> = (props) => {

    
    const propertyChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    const onChangeMinAge = (event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {

                props.propertyChanged("minAge", newValue);
            }
        }
    }
    

    const onChangeMaxAge =(event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {
                props.propertyChanged("maxAge", newValue);
            }
        }
    }

    const validate = (item: IAgeGoup)=>
    {
        props.valid(true);
    }

    React.useEffect(() => {
        validate(props.item);
    }, [props.item])

    return (<Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>
        <TextField required id="name" key="name" underlined label="Název" disabled={props.isLoading} value={props.item.name}
            onChange={propertyChanged} />

        <TextField id="description" key="description" underlined multiline label="Popis" disabled={props.isLoading} value={props.item.description}
            onChange={propertyChanged} rows={3} />
        <Stack horizontal >
        <SpinButton
            id="minAge"
            key="minAge"
            label="Min. věk"
            value={props.item.minAge.toString()}
            min={0}
            max={100}
            step={1}
                onChange={onChangeMinAge}
            incrementButtonAriaLabel="Zvýší hodnotu o 1"
            decrementButtonAriaLabel="Sníží hodnotu o 1"
                styles={styles} />

        <SpinButton
            id="maxAge"
            key="maxAge"
            label="Max. věk"
            value={props.item.maxAge.toString()}
            min={0}
            max={100}
            step={1}
                onChange={onChangeMaxAge}
            incrementButtonAriaLabel="Zvýší hodnotu o 1"
            decrementButtonAriaLabel="Sníží hodnotu o 1"
            styles={styles}/>
            </Stack>
        </Stack>)
}